import React from 'react'

function Ppt() {
  return (
    <div>Ppt</div>
  )
}

export default Ppt